'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');
var MultilineText = require('./common/MultilineText');

var PageRemark = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    remark: React.PropTypes.string,
    show: React.PropTypes.bool.isRequired,
    onClose: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      show: false
    };
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      show: nextProps.show
    });
  },
  render: function () {
    var style = {};
    if (this.state.show && this.props.remark) {
      style.right = 0;
    } else {
      style.right = -220;
    }

    return (
      <div className="page-remark" style={style}>
        <img onClick={this.onCloseRemark} className="close" src={assetsHelper.getAsset('close-30.png')}/>
        <h3 className="page-name">{this.props.name}</h3>
        <div className="page-remark-content" >
          <MultilineText text={this.props.remark}/>
        </div>
      </div>
    )
  },
  onCloseRemark: function () {
    this.props.onClose();
  }
});

module.exports = PageRemark;


// WEBPACK FOOTER //
// ./src/views/PageRemark.jsx